export function changeMainTextColorAction (mainTextColor) {
	return {
		type: 'CHANGE_MAIN_TEXT_COLOR',
		payload: mainTextColor
	}
}